import React from 'react';
import {
  Col,
  Row,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';

const DummyTaxTemplate = () => (
  <div className="mb-2">
    <Row>
      <Col xs={4}>
        <h3>Charge Type: Tax</h3>
      </Col>
    </Row>
    <Row>
      <Col xs={3}>
        <FormGroup>
          <h3>Name</h3>
          US Sales Tax
        </FormGroup>
      </Col>
      <Col xs={2}>
        <FormGroup>
          <h3>Rate %</h3>
          Auto-Calculated
        </FormGroup>
      </Col>
      <Col xs={3}>
        <FormGroup>
          <h3>Country / Region</h3>
          United States of America
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col xs={3}>
        <h3>Apply tax type to:</h3>
      </Col>
      <Col xs={2}>
        <FormGroup check>
          <Input
            type="checkbox"
            id="taxHammer"
            name="taxHammer"
            checked={true}
            disabled={true}
          />
          <Label check>
            Hammer
          </Label>
        </FormGroup>
      </Col>
      <Col xs={2}>
        <FormGroup check>
          <Input
            type="checkbox"
            id="taxLiveFee"
            name="taxLiveFee"
            checked={true}
            disabled={true}
          />
          <Label check>
            Live Fee
          </Label>
        </FormGroup>
      </Col>
      <Col xs={2}>
        <FormGroup check>
          <Input
            type="checkbox"
            id="taxPremium"
            name="taxPremium"
            checked={true}
            disabled={true}
          />
          <Label check>
            BP
          </Label>
        </FormGroup>
      </Col>
    </Row>
  </div>
);

export default DummyTaxTemplate;
